import { useEffect } from 'react';
import {
  IPortalContactResponse,
  IPortalInvoiceResponse,
  IPortalQuoteResponse,
} from 'shared';

import { env } from '../../common/lib/env';
import { LogRocket, linkLogRocketSession } from '../../common/lib/logrocket';

let initialised = false;

/**
 * Records a LogRocket replay of the portal visit when the org has PORTAL_SESSION_REPLAY.
 * Identifies by the verified email when there is one, otherwise the portal analytics session.
 */
export function usePortalLogRocket(
  data: IPortalContactResponse | IPortalInvoiceResponse | IPortalQuoteResponse | undefined,
  sessionId: string | undefined,
) {
  const enabled = env.isProd && !!data?.logrocket;
  const email = data?.secureSessionUserEmail;
  const contactName = (data && `statement` in data ? data.statement?.contact.name : undefined)
    ?? (data && `invoice` in data ? data.invoice?.contact.name : undefined)
    ?? (data && `contact` in data ? data.contact?.name : undefined);
  const organisationId = data?.organisationId;
  const organisationName = data?.senderDetail?.customerFacingCompanyName;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!initialised) {
      LogRocket.init(env.logrocketAppId);
      linkLogRocketSession();
      initialised = true;
    }

    const uid = email ?? sessionId;

    if (uid) {
      LogRocket.identify(uid, {
        ...(email ? { email } : {}),
        ...(contactName ? { name: contactName } : {}),
        ...(organisationId ? { organisationId } : {}),
        ...(organisationName ? { organisationName } : {}),
        portal: true,
      });
    }
  }, [enabled, email, sessionId, contactName, organisationId, organisationName]);
}
